module.exports = __webpack_public_path__ + "static/img/robotImg.3e639b8.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/robotImg.png
// module id = eD1H
// module chunks = 1